// removed by extract-text-webpack-plugin
module.exports = {"productList":"G1c5982"};